import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {TaxSearchPageComponent} from "./tax/tax-search-page/tax-search-page.component";
import {
    EmailSettingSearchPageComponent
} from "./email-setting/email-setting-search-page/email-setting-search-page.component";
import {
    CreditCardMappingSearchPageComponent
} from "./credit-card-mapping/credit-card-mapping-search-page/credit-card-mapping-search-page.component";
import {
    EventTriggerSearchPageComponent
} from "./event-trigger/event-trigger-search-page/event-trigger-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {
    CompanyDetailsEditPageComponent
} from "./company-details/company-details-edit-page/company-details-edit-page.component";
import {
    CompanyDetailsSearchPageComponent
} from "./company-details/company-details-search-page/company-details-search-page.component";
import {
    CompanyDetailsEditDetailsComponent
} from "./company-details/company-details-edit-page/company-details-edit-details/company-details-edit-details.component";
import {SystemSharedModule} from "./system.shared.module";
import {AddressSharedModule} from "../address/address.shared.module";
import {TaxEditPageComponent} from "./tax/tax-edit-page/tax-edit-page.component";
import {EmailSettingEditPageComponent} from "./email-setting/email-setting-edit-page/email-setting-edit-page.component";
import {
    CompanyDetailsEditAdditionalInformationComponent
} from "./company-details/company-details-edit-page/company-details-edit-additional-information/company-details-edit-additional-information.component";
import {
    CompanyDetailsEditTaxesReceiptComponent
} from "./company-details/company-details-edit-page/company-details-edit-taxes-receipt/company-details-edit-taxes-receipt.component";
import {LicenseSearchPageComponent} from "./license/license-search-page/license-search-page.component";
import {FileImportPageComponent} from "./file-import/file-import-page/file-import-page.component";
import {
    PeriodScheduleSearchPageComponent
} from "./period-schedule/period-schedule-search-page/period-schedule-search-page.component";
import {
    PeriodScheduleEditPageComponent
} from "./period-schedule/period-schedule-edit-page/period-schedule-edit-page.component";
import {
    AppLayoutFileImportPageComponent
} from "./file-import/app-layout-file-import-page/app-layout-file-import-page.component";
import {
    CompanyDeleteSearchActionComponent
} from "./company-details/company-details-search-page/company-delete-search-action.component";
import {CustomersSharedModule} from "../customers/customers.shared.module";
import {OrderProcessingSharedModule} from "../order-processing/order-processing.shared.module";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {PosSharedModule} from "../pos/pos.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        AddressSharedModule,
        SystemSharedModule,
        CustomersSharedModule,
        CatalogueSharedModule,
        PricingSharedModule,
        OrderProcessingSharedModule,
        PosSharedModule
    ],
    declarations: [
        TaxSearchPageComponent,
        EmailSettingSearchPageComponent,
        EmailSettingEditPageComponent,
        CreditCardMappingSearchPageComponent,
        EventTriggerSearchPageComponent,
        CompanyDeleteSearchActionComponent,
        CompanyDetailsSearchPageComponent,
        CompanyDetailsEditPageComponent,
        CompanyDetailsEditDetailsComponent,
        CompanyDetailsEditAdditionalInformationComponent,
        CompanyDetailsEditTaxesReceiptComponent,
        TaxEditPageComponent,
        LicenseSearchPageComponent,
        PeriodScheduleSearchPageComponent,
        PeriodScheduleEditPageComponent,
        FileImportPageComponent,
        AppLayoutFileImportPageComponent
    ],
    exports: [
        TaxSearchPageComponent,
        EmailSettingSearchPageComponent,
        EmailSettingEditPageComponent,
        CreditCardMappingSearchPageComponent,
        EventTriggerSearchPageComponent,
        CompanyDeleteSearchActionComponent,
        CompanyDetailsSearchPageComponent,
        CompanyDetailsEditPageComponent,
        CompanyDetailsEditDetailsComponent,
        CompanyDetailsEditAdditionalInformationComponent,
        CompanyDetailsEditTaxesReceiptComponent,
        TaxEditPageComponent,
        LicenseSearchPageComponent,
        PeriodScheduleSearchPageComponent,
        PeriodScheduleEditPageComponent,
        FileImportPageComponent,
        AppLayoutFileImportPageComponent
    ]
})
export class SystemModule {
}
